import { AnyAction } from 'redux';
import { CommanderThunkAction } from '@mews-commander/types';
import { getCurrentEnterpriseId, getCurrentProfileId } from '@mews-commander/core';
import { hasEnterpriseProfile } from '@mews-commander/legacy-entities/src/ducks/enterpriseProfiles';
import { fetchEnterpriseProfile } from '@mews-commander/legacy-entities/src/actions/enterpriseProfiles';
import { hasProfile } from '@mews-commander/legacy-entities/src/ducks/profiles';

export const fetchCurrentEnterpriseProfileWithCheck = (): CommanderThunkAction<AnyAction> => (dispatch, getState) => {
    const state = getState();
    const currentProfileId = getCurrentProfileId();
    const currentEnterpriseId = getCurrentEnterpriseId();

    if (
        hasProfile(state, { id: currentProfileId }) ||
        hasEnterpriseProfile(state, { id: currentProfileId, enterpriseId: currentEnterpriseId })
    ) {
        return;
    }

    dispatch(
        fetchEnterpriseProfile({
            enterpriseProfileId: currentProfileId,
            enterpriseId: currentEnterpriseId,
            extent: {
                actors: false,
                users: true,
                departments: false,
                cashierAssignments: false,
                cashiers: false,
                roleAssignments: false,
            },
        })
    );
};
